module.exports = __webpack_public_path__ + "img/logo-md.d3ce073d.png";